import { observer } from 'mobx-react-lite';
import { ILeaseCompFilterSettings } from '../../interfaces/IFilterSettings';
import { LeaseCompPropertyType } from '../../interfaces/ILeaseComp';
import { leaseCompPropertyTypeToString } from '../../utils/enumUtils';
import { formatDateForInput, parseDate } from '../../utils/utils';
import styles from './GlobalFilters.module.css';

function GlobalFiltersLeaseCompsTab({ leaseCompFiltersState, setLeaseCompFiltersState }: IGlobalFiltersLeaseCompsTabProps) {
    return (
        <div className={styles.columns}>
            <div className={styles.column}>
                <label className={styles.label}>
                    TENANT LAND SIZE
                    <div>
                        <input type="number" className={styles.numberInput} placeholder="Enter min" value={leaseCompFiltersState.minTenantLandSize || ""} onChange={e => setLeaseCompFiltersState({
                            ...leaseCompFiltersState,
                            minTenantLandSize: e.target.valueAsNumber || null,
                        })} />
                        &nbsp;-&nbsp;
                        <input type="number" className={styles.numberInput} placeholder="Enter max" value={leaseCompFiltersState.maxTenantLandSize || ""} onChange={e => setLeaseCompFiltersState({
                            ...leaseCompFiltersState,
                            maxTenantLandSize: e.target.valueAsNumber || null,
                        })} />
                    </div>
                </label>
                <label className={styles.label}>
                    BUILDING SIZE
                    <div>
                        <input type="number" className={styles.numberInput} placeholder="Enter min" value={leaseCompFiltersState.minBuildingSize || ""} onChange={e => setLeaseCompFiltersState({
                            ...leaseCompFiltersState,
                            minBuildingSize: e.target.valueAsNumber || null,
                        })} />
                        &nbsp;-&nbsp;
                        <input type="number" className={styles.numberInput} placeholder="Enter max" value={leaseCompFiltersState.maxBuildingSize || ""} onChange={e => setLeaseCompFiltersState({
                            ...leaseCompFiltersState,
                            maxBuildingSize: e.target.valueAsNumber || null,
                        })} />
                    </div>
                </label>
            </div>
            <div className={styles.column}>
                <label className={styles.label}>
                    ANNUAL RENT
                    <div>
                        <input type="number" className={styles.numberInput} placeholder="Enter min" value={leaseCompFiltersState.minAnnualRent || ""} onChange={e => setLeaseCompFiltersState({
                            ...leaseCompFiltersState,
                            minAnnualRent: e.target.valueAsNumber || null,
                        })} />
                        &nbsp;-&nbsp;
                        <input type="number" className={styles.numberInput} placeholder="Enter max" value={leaseCompFiltersState.maxAnnualRent || ""} onChange={e => setLeaseCompFiltersState({
                            ...leaseCompFiltersState,
                            maxAnnualRent: e.target.valueAsNumber || null,
                        })} />
                    </div>
                </label>
                <label className={styles.label}>
                    LEASE EXPIRATION
                    <div>
                        <input type="date" className={styles.numberInput} value={formatDateForInput(leaseCompFiltersState.minLeaseExpiration || undefined)} onChange={e => setLeaseCompFiltersState({
                            ...leaseCompFiltersState,
                            minLeaseExpiration: parseDate(e.target.value) || null,
                        })} />
                        &nbsp;-&nbsp;
                        <input type="date" className={styles.numberInput} value={formatDateForInput(leaseCompFiltersState.maxLeaseExpiration || undefined) || ""} onChange={e => setLeaseCompFiltersState({
                            ...leaseCompFiltersState,
                            maxLeaseExpiration: parseDate(e.target.value) || null,
                        })} />
                    </div>
                </label>
                <label className={styles.label}>
                    DATE MODIFIED
                    <div>
                        <input type="date" className={styles.numberInput} value={formatDateForInput(leaseCompFiltersState.minDateModified || undefined)} onChange={e => setLeaseCompFiltersState({
                            ...leaseCompFiltersState,
                            minDateModified: parseDate(e.target.value) || null,
                        })} />
                        &nbsp;-&nbsp;
                        <input type="date" className={styles.numberInput} value={formatDateForInput(leaseCompFiltersState.maxDateModified || undefined) || ""} onChange={e => setLeaseCompFiltersState({
                            ...leaseCompFiltersState,
                            maxDateModified: parseDate(e.target.value) || null,
                        })} />
                    </div>
                </label>
                <label className={styles.label}>
                    PROPERTY TYPE
                    <div className={styles.tags}>
                        {Object.values(LeaseCompPropertyType).map(propertyType => (
                            <div
                                key={propertyType}
                                className={leaseCompFiltersState.propertyTypes.includes(propertyType) ? styles.selectedTag : styles.tag}
                                onClick={() => setLeaseCompFiltersState({
                                    ...leaseCompFiltersState,
                                    propertyTypes: !leaseCompFiltersState.propertyTypes.includes(propertyType) ? [
                                        ...leaseCompFiltersState.propertyTypes,
                                        propertyType,
                                    ] : leaseCompFiltersState.propertyTypes.filter(s => s !== propertyType),
                                })}
                            >
                                {leaseCompPropertyTypeToString(propertyType)}
                            </div>
                        ))}
                    </div>
                </label>
            </div>
        </div>
    );
};

export default observer(GlobalFiltersLeaseCompsTab);

interface IGlobalFiltersLeaseCompsTabProps {
    leaseCompFiltersState: ILeaseCompFilterSettings;
    setLeaseCompFiltersState: (value: ILeaseCompFilterSettings) => void;
}